import type { Article } from "../../support.types";

export type Props = {
  /** Title for the article list */
  title: string;
  /** Array of articles to display */
  articles: Article[];
  /** Callback when an article is clicked */
  onArticleClick: (article: Article) => void;
  /** Render function for the title */
  renderTitle: (title: string) => React.ReactNode;
  /** Render function for each article item */
  renderArticle: (props: {
    article: Article;
    onClick: () => void;
  }) => React.ReactNode;
  /** Render function for empty state */
  renderEmpty?: () => React.ReactNode;
  /** Optional className for the container */
  className?: string;
};

/**
 * Base component for displaying a list of support articles.
 * Uses render props for styling - no CSS included.
 */
export function SupportArticleListBase({
  title,
  articles,
  onArticleClick,
  renderTitle,
  renderArticle,
  renderEmpty,
  className,
}: Props) {
  return (
    <section className={className} data-testid="support-article-list">
      {renderTitle(title)}
      {articles.length === 0 ? (
        renderEmpty?.() ?? null
      ) : (
        <ul role="list" aria-label={title}>
          {articles.map((article) => (
            <li key={article.id}>
              {renderArticle({
                article,
                onClick: () => onArticleClick(article),
              })}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

export default SupportArticleListBase;

